// Libraries
var React = require('react');

// Styles
require('./Loader.scss');

class Loader extends React.Component {
	render() {
		return (
			<span className={`c-loader ${this.props.inline ? "c-loader--inline" : ""}`}>
				<span className="u-visually-hidden">Loading...</span>
			</span>
		)
	}
}

module.exports = Loader;



// WEBPACK FOOTER //
// ./src/common/Loader/Loader.js